var KR_I18n = KR_I18n || {};

KR_I18n["es-PE"] = {"amount":"Monto"};

if ((typeof(module) !== "undefined") && (typeof(module.exports) !== "undefined")) module.exports = KR_I18n["es-PE"];

